// extracted by mini-css-extract-plugin
module.exports = {"form":"ContactForm_form__1fuOn","title":"ContactForm_title__3MqSl","success":"ContactForm_success__2A0ds","ph":"ContactForm_ph__2dnhU","submitBtn":"ContactForm_submitBtn__J-Qu6"};